/* CSS handles the grid and product order. Only compact decorative artwork into
   unused vertical space; never move it through preceding product text. */
if (!customElements.get('collection-layout')) {
  customElements.define('collection-layout', class extends HTMLElement {
    connectedCallback() {
      this.grid = this.querySelector('.collection-shop__grid');
      if (!this.grid) return;
      this.wide = matchMedia('(min-width: 750px)');
      this.schedule = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.layout());
      };
      this.observer = new ResizeObserver(this.schedule);
      // Observe content, not the grid tracks that this component adjusts.
      this.querySelectorAll('.product-card, figure').forEach(item => this.observer.observe(item));
      this.wide.addEventListener('change', this.schedule);
      document.fonts.ready.then(() => { if (this.isConnected) this.schedule(); });
      this.schedule();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.wide?.removeEventListener('change', this.schedule);
      cancelAnimationFrame(this.frame);
    }

    layout() {
      const artwork = [...this.querySelectorAll('[data-desktop-raise]')];
      artwork.forEach(item => item.style.removeProperty('margin-top'));
      if (!this.wide.matches) return;
      const items = [...this.grid.children].sort((a, b) =>
        Number(getComputedStyle(a).order) - Number(getComputedStyle(b).order));
      const scale = this.grid.getBoundingClientRect().width / 1200;
      const gap = parseFloat(getComputedStyle(this.grid).rowGap) || 0;
      for (const [index, item] of items.entries()) {
        const requested = Number(item.dataset.desktopRaise) * scale;
        if (!(requested > 0)) continue;
        const box = item.getBoundingClientRect();
        const clearance = Number(item.dataset.desktopClearance) * scale || gap;
        let limit = this.grid.getBoundingClientRect().top - clearance;
        for (const previous of items.slice(0, index)) {
          const rect = previous.getBoundingClientRect();
          if (rect.left < box.right - 1 && rect.right > box.left + 1) {
            limit = Math.max(limit, rect.bottom);
          }
        }
        const lift = Math.min(requested, Math.max(0, box.top - limit - clearance));
        item.style.marginTop = `${-lift}px`;
      }
    }
  });
}
